import { useContext } from 'react'
import { FiltersContext } from '@/context'

export const useFilters = () => {
  const ctx = useContext(FiltersContext)
  if (!ctx) throw new Error('useFilters must be used within a useFiltersProvider')
  return ctx
}
